import { render, staticRenderFns } from "./SafetyAssessment.vue?vue&type=template&id=e093f89e&scoped=true"
import script from "./SafetyAssessment.vue?vue&type=script&lang=js"
export * from "./SafetyAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e093f89e",
  null
  
)

export default component.exports